import React, { useState, useEffect, useRef, useMemo } from "react"
import { useQuery, useQueryClient } from "react-query"
import { fetchDeals } from "../../../services/main.service"
import Paginator from "../../composites/paginator"
import WithAuth from "../../hoc/with-auth"
import { LayoutWithSidebar } from "../../layouts/layout-with-sidebar.tsx"
import {
  Badge,
  Box,
  Flex,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
  Grid,
  GridItem,
  Button,
  Input,
  IconButton,
  Link as Clink,
} from "@chakra-ui/react"
import _ from "lodash"
import BlockedLoader from "../../composites/blocked-loader"
import DateRangePicker from "../../composites/date-range-picker"
import { AiOutlineSearch } from "react-icons/ai"
import { InputWrapper } from "../../composites"
import { ReactSelect } from "../../composites/select"
import { SelectSymbols } from "../../composites/select-symbols"
import { CSVLink, CSVDownload } from "react-csv"
import { AiOutlineDownload } from "react-icons/ai"
import App from "../../../App"
import { app } from "../../../config"
import { formatDate, formatSecondsToDate } from "../../../utils"
import { getAllAccounts, getAllPositions } from "../../../services/crm.service"
import { AgGridReact } from "ag-grid-react"
import { PositionReasonEnum } from "../../../enum/Position.ts"

const PositionPage = () => {
  const {
    data,
    isLoading,
    isError,
    isRefetching,
    isFetched,
    isFetchedAfterMount,
    refetch,
  } = useQuery(["positions"], () => getAllPositions(), {
    refetchInterval: 4000,
  })

  const gridRef = useRef<any>() // Optional - for accessing Grid's API
  const [rowData, setRowData] = useState() // Set rowData to Array of Objects, one Object per Row

  // [{"login":1000,"balance":0,"equity":0,"credit":0,"margin_used":0,"margin_level":0,"margin_free":0,"group":null},{"login":1001,"balance":0,"equity":0,"credit":0,"margin_used":0,"margin_level":0,"margin_free":0,"group":null},
  // Each Column Definition results in one Column.

  const [columnDefs, setColumnDefs] = useState([
    { headerName: "Position", field: "position" },
    { headerName: "Login", field: "login" },
    { headerName: "Symbol", field: "symbol" },
    { headerName: "Type", field: "type" },
    {
      headerName: "Profit",
      field: "profit",
      cellRenderer: (params: any) => {
        if (isNaN(params?.value)) return params?.value
        return <>{parseFloat(params?.value).toFixed(2)}</>
      },
    },
    {
      headerName: "Volume",
      field: "volume",
      cellRenderer: (params: any) => {
        if (params?.value === "") return ""

        // @ts-ignore
        return <>{parseFloat(params?.value / 10000)}</>
      },
    },
    {
      headerName: "Price",
      field: "price",
      cellRenderer: (params: any) => {
        if (isNaN(params?.value)) return params?.value
        return <>{parseFloat(params?.value).toFixed(2)}</>
      },
    },
    {
      headerName: "priceOpen",
      field: "priceOpen",
      cellRenderer: (params: any) => {
        if (isNaN(params?.value)) return params?.value
        return <>{parseFloat(params?.value).toFixed(2)}</>
      },
    },
    // formatSecondsToDate(_d?.time)
    {
      headerName: "time",
      field: "time",
      cellRenderer: (params: any) => {
        if (params?.value === "") return ""
        return <>{formatSecondsToDate(params?.value)}</>
      },
    },
    { headerzName: "sl", field: "sl" },
    { headerName: "tp", field: "tp" },
    { headerName: "comment", field: "comment" },
    {
      headerName: "Reason",
      field: "reason",
      cellRenderer: (params: any) => {
        if (params?.value === "") return ""
        return <>{PositionReasonEnum[params?.value]}</>
      },
    },
  ])

  // DefaultColDef sets props common to all Columns
  const defaultColDef = useMemo(
    () => ({
      // make every column editable
      editable: false,
      selectable: true,
      // make every column use 'text' filter by default
      filter: "agTextColumnFilter",
      // enable floating filters by default
      floatingFilter: true,
      // make columns resizable
      resizable: true,
      // disable cell data types
      cellDataType: false,
      sortable: true,
    }),
    []
  )

  const pinnedBottomData = useMemo(() => {
    let pinnedData: any[] = [{}]

    if (data?.data?.data?.length) {
      pinnedData = [
        {
          position: "",
          login: "",
          symbol: "",
          type: "",
          profit: _.sumBy(data?.data?.data, "profit").toFixed(2),
          price: "",
          priceOpen: "",
          time: "",
          sl: "",
          tp: "",
          comment: "",
          reason: "",
          volume: "",
        },
      ]
    }

    return pinnedData
  }, [data?.data?.data])

  return (
    <>
      <div className="ag-grid-container">
        <div
          className="ag-theme-alpine"
          style={{ width: "100%", height: "calc(100vh - 100px)" }}
        >
          <AgGridReact
            suppressScrollOnNewData={true}
            ref={gridRef} // Ref for accessing Grid's API
            rowData={data?.data?.data ?? []} // Row Data for Rows
            columnDefs={columnDefs} // Column Defs for Columns
            defaultColDef={defaultColDef} // Default Column Properties
            animateRows={true} // Optional - set to 'true' to have rows animate when sorted
            overlayNoRowsTemplate={
              isLoading ? "Loading Positions..." : "No open positions found"
            }
            pinnedBottomRowData={pinnedBottomData}
          />
        </div>
      </div>
    </>
  )
}

export default PositionPage
